import axios from 'axios';

import config from '@/config';

import { API_REQUEST_TIMEOUT } from '../constants';

export const apiClient = axios.create({
  baseURL: `https://${config.SERVICES.V2}/${config.ENV}`,
  timeout: API_REQUEST_TIMEOUT,
});
